<template>
  <div>
    <span
      :class="cn('text-gray-500 cursor-pointer hover:text-gray-600', iconClasses)"
      @mouseenter="showBubble = true"
      @mouseleave="showBubble = false"
    >
      <InfoRoundedIcon />
    </span>
    <div class="relative">
      <div
        v-if="showBubble"
        :class="`text-dark absolute z-[9999] -ml-4 mb-7 inline-block whitespace-normal rounded-lg border-inherit bg-[#E9F3F2] px-4 py-3 ${position === 'left' ? 'right-full translate-x-8 w-[450px] -bottom-2' : 'bottom-0 w-[380px]'} ${bubbleClasses}`"
        x-show="hover"
        x-transition:enter="transition ease-out duration-300"
        x-transition:enter-start="opacity-0 transform scale-90"
        x-transition:enter-end="opacity-100 transform scale-100"
        x-transition:leave="transition ease-in duration-300"
        x-transition:leave-start="opacity-100 transform scale-100"
        x-transition:leave-end="opacity-0 transform scale-90"
        x-cloak
      >
        <span class="inline-block text-sm leading-tight text-dark">
          {{ title }}
        </span>
        <span
          :class="cn(
            'absolute bottom-0 -mb-1 h-4 w-4 rotate-45 transform bg-[#E9F3F2]',
            {
              '-left-8 translate-x-[380px]': position === 'left',
              'left-[5%]': position === 'right',
            },
            pointerClasses,
          )"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelperText',

  props: {
    title: {
      type: String,
      required: true,
    },
    position: {
      type: String,
      default: 'right',
    },
    iconClasses: {
      type: String,
      default: '',
    },
    bubbleClasses: {
      type: String,
      default: '',
    },
    pointerClasses: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      showBubble: false,
    }
  },

  mounted() {
    if (!['right', 'left'].includes(this.position)) {
      throw new Error(
        `The value of the position attribute is invalid. Accepted values are either right or left. Provided value: "${this.position}"`,
      )
    }
  },
}
</script>
